var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-map',{ref:"mapaUnidadeDeSaude",staticStyle:{"height":"500px","width":"100%"},attrs:{"zoom":_vm.zoom,"center":_vm.center,"options":{ zoomControl: false }},on:{"update:zoom":function($event){_vm.zoom=$event}}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_c('l-control-zoom',{attrs:{"position":"bottomright"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }